import {env} from '@/config';
import {useAppSelector} from '@/redux-store/store';
import {EventData} from '@/types/event';
import {
  isDocumentCompanyRoleHealthManager,
  isUserDocumentManager
} from '@/utils';
import {isUserEventParticipant} from './is-event-participant';
import {isEventPaidWithParticipants} from './is-event-paid-with-participants';

export const useEventPermissions = (event: EventData, pastEvent: boolean) => {
  const {APP_VARIANT} = env;
  const {isAuthenticated, isUserHealthManager} = useAppSelector(
    (state) => state.auth
  );
  const userData = useAppSelector((state) => state.userInfos.userInfos);

  const isUserManager = isUserDocumentManager(event, userData);
  const isHealthManagerEvent = isDocumentCompanyRoleHealthManager(event);
  const companyEventAndUserHealthManager =
    isUserHealthManager && isHealthManagerEvent;

  const isUserParticipant = isUserEventParticipant(event, userData._id);
  const isPaidEvent = event.isPaid;
  const eventCancelled = event.status === 'CANCELLED';
  const eventPaidWithParticipants = isEventPaidWithParticipants(
    event,
    userData._id
  );

  return {
    canEditEvent:
      !eventPaidWithParticipants &&
      (isUserManager || companyEventAndUserHealthManager) &&
      !eventCancelled &&
      !pastEvent,
    canCloneEvent:
      isUserManager || (APP_VARIANT !== 'sportjoe' && isAuthenticated),
    canDeleteEvent:
      !eventPaidWithParticipants &&
      (isUserManager || companyEventAndUserHealthManager),
    canCancelEvent:
      !eventPaidWithParticipants &&
      (isUserManager || companyEventAndUserHealthManager) &&
      !eventCancelled &&
      !pastEvent,
    canLeaveEvent:
      isUserParticipant &&
      !pastEvent &&
      (!isUserManager || companyEventAndUserHealthManager),
    isPaidEvent,
    isUserManager
  };
};
